import { BefPage } from "@beflam/bef-core";

const createComponentPage = (componentName: string, props?: any) => {
    let page = new BefPage('', '', componentName);
    let defaultProps = {
        id: '',
        style: {
            flex: 1,
            width: '100%',
        },
    }
    //如果存在props，则合并props
    if (props) {
        defaultProps = { ...defaultProps, ...props };
    }
    page.renderSchema = {
        ChildrenSchema: {
            componentsTree: [
                {
                    id: 'node_dockcviv8fo1',
                    componentName: 'Page',
                    props: {
                        ref: 'outerView',
                        style: {
                            height: '100%',
                        },
                    },
                    children: [
                        {
                            id: 'node_oclgn36ive1',
                            componentName: 'FDPage',
                            props: {
                                contentProps: {
                                    style: {
                                        background: 'rgba(255,255,255,0)',
                                    },
                                },
                                style: {
                                    backgroundColor: "rgba(255,255,255,0)",
                                    display: "flex"
                                }
                            },
                            children: [
                                {
                                    id: 'node_oclgn36ive2',
                                    componentName: 'FDSection',
                                    props: {
                                        style: {
                                            backgroundColor: 'rgba(255,255,255,0)',
                                            minHeight: '',
                                            paddingBottom: '0px',
                                            paddingLeft: '0px',
                                            paddingRight: '0px',
                                            paddingTop: '0px',
                                            flex: 1,
                                            overflow: "auto",
                                            display: "flex"
                                        },
                                    },
                                    children: [
                                        {
                                            id: 'node_oclgn36ive3',
                                            componentName: 'FDBlock',
                                            props: {
                                                mode: 'transparent',
                                                span: 12,
                                                style: {
                                                    backgroundColor: 'rgba(255,255,255,0)',
                                                },
                                            },
                                            children: [
                                                {
                                                    id: 'node_oclgn36ive4',
                                                    componentName: 'FDCell',
                                                    props: {
                                                        align: 'left',
                                                        verAlign: 'top',
                                                        style: {
                                                            backgroundColor: 'rgba(255,255,255,1)',
                                                            minHeight: '',
                                                            flex: 1,
                                                            overflow: "auto",
                                                        },
                                                        width: '',
                                                    },
                                                    children: [
                                                        {
                                                            id: 'node_oclmtzqnor1',
                                                            componentName: componentName,
                                                            props: defaultProps,
                                                            children: [],
                                                            isLocked: false,
                                                            title: '',
                                                            ignore: false,
                                                            hidden: false,
                                                            condition: true,
                                                            conditionGroup: '',
                                                            defaultProps: null,
                                                        },
                                                    ],
                                                    isLocked: false,
                                                    title: '容器',
                                                    ignore: false,
                                                    hidden: false,
                                                    condition: true,
                                                    conditionGroup: '',
                                                    defaultProps: null,
                                                },
                                            ],
                                            isLocked: false,
                                            title: '区块',
                                            ignore: false,
                                            hidden: false,
                                            condition: true,
                                            conditionGroup: '',
                                            defaultProps: null,
                                        },
                                    ],
                                    isLocked: false,
                                    title: '区域',
                                    ignore: false,
                                    hidden: false,
                                    condition: true,
                                    conditionGroup: '',
                                    defaultProps: null,
                                },
                            ],
                            isLocked: false,
                            title: '页面',
                            ignore: false,
                            hidden: false,
                            condition: true,
                            conditionGroup: '',
                            defaultProps: null,
                        },
                    ],
                    isLocked: false,
                    title: '',
                    ignore: false,
                    hidden: false,
                    condition: true,
                    conditionGroup: '',
                    defaultProps: null,
                },
            ],
            i18n: {
                'zh-CN': {},
                'en-US': {},
            },
        },
        DataSourceData: [],
    };
    return page;
};

export { createComponentPage };